!function() {
  "use strict";
  if (customElements.get("video-popup")) return;

  function fitNativeVideoInPopup() {
    var root = document.querySelector(".pswp--open");
    if (!root) return;
    var video = root.querySelector(".pswp__custom-native video");
    if (!video) return;
    var outer = video.closest(".iframe-outer");
    if (!outer) return;

    function apply() {
      if (!video.videoWidth || !video.videoHeight) return;
      var vw = video.videoWidth;
      var vh = video.videoHeight;
      var maxW = Math.min(window.innerWidth * 0.92, 920);
      var maxH = window.innerHeight * 0.85;
      var r = vw / vh;
      var boxW;
      var boxH;
      if (maxW / maxH > r) {
        boxH = maxH;
        boxW = boxH * r;
      } else {
        boxW = maxW;
        boxH = boxW / r;
      }
      outer.classList.add("pswp__custom-native--fit");
      outer.style.width = boxW + "px";
      outer.style.height = boxH + "px";
      outer.style.maxWidth = "100%";
      video.style.width = "100%";
      video.style.height = "100%";
      video.style.objectFit = "contain";
    }

    if (video.readyState >= 1) {
      apply();
    } else {
      video.addEventListener("loadedmetadata", apply, { once: true });
    }
  }

  customElements.define("video-popup", class extends HTMLElement {
    constructor() {
      super();
      this.a11y = window.theme.a11y;
      this.onPlayClick = this.onPlayClick.bind(this);
      this.onPopupInit = this.onPopupInit.bind(this);
    }

    onPopupInit() {
      var self = this;
      requestAnimationFrame(function() {
        fitNativeVideoInPopup();
      });
    }

    onPlayClick(e) {
      var playButton = e.currentTarget;
      if (!playButton.getAttribute("data-video-play") || !playButton.getAttribute("data-video-play").trim()) return;
      e.preventDefault();
      this.a11y.state.trigger = playButton;
      new window.theme.LoadPhotoswipe(
        [{ html: playButton.getAttribute("data-video-play") }],
        { mainClass: "pswp--video" },
        0,
        playButton
      );
    }

    connectedCallback() {
      var self = this;
      this.querySelectorAll("[data-video-play]").forEach(function(btn) {
        btn.addEventListener("click", self.onPlayClick);
        btn.addEventListener("theme:popup:init", self.onPopupInit);
      });
    }

    disconnectedCallback() {
      var self = this;
      this.querySelectorAll("[data-video-play]").forEach(function(btn) {
        btn.removeEventListener("click", self.onPlayClick);
        btn.removeEventListener("theme:popup:init", self.onPopupInit);
      });
    }
  });
}();
